import { normalizeShopIdentifier } from "../../app/utils/productGuideFeature";

// Klaviyo is public; supplier integrations keep their existing merchant allowlist.
const vendorIntegrationShops = [
    "trail-ops-staging", "trail-ops-staging.myshopify.com",
    "jeepsterstampa", "jeepsterstampa.myshopify.com",
    "trailops727.com", "www.trailops727.com",
];

export const showsVendorIntegrations = (shopDomain?: string) =>
    vendorIntegrationShops.includes(normalizeShopIdentifier(shopDomain));
